import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sites: [],
    activeSite: {},
  },
  mutations: {
    AddSite(state, site) {
      state.sites.push(site);
    },
    ChangeSite(state, site) {
      state.activeSite = site;
      localStorage.setItem("activeSite", JSON.stringify(site));
    },
  },
  getters: {
    activeSite: (state) => state.activeSite,
    sites: (state) => state.sites,
  },
  actions: {},
  modules: {},
});
